(function () {
  if (window.alacPdpStoryReviews) return;
  const skip = /reflux|gerd|heartburn|stomach|tummy|gut\b|ulcer|doctor|ibs\b|gastr|digest|pain|medic|symptom|sick|nause|burn|cure|heal|disease|condition|acid ?free/i;
  let observer;
  let request;

  function unmount() {
    observer?.disconnect();
    request?.abort();
    observer = null;
    request = null;
  }

  function mount() {
    unmount();
    const box = document.querySelector('[data-alac-reviews][data-product-id]');
    if (!box || !window.fetch) return;
    const all = box.querySelector('[data-alac-reviews-all]');
    all?.addEventListener('click', event => {
      const target = document.querySelector('.junipreviewsection, .junip-product-review');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    const key = document.querySelector('.junip-store-key')?.dataset.storeKey;
    if (!key) return;
    function load() {
      request = new AbortController();
      const url = 'https://api.juniphq.com/v1/product_reviews?filter%5Bproduct_remote_ids%5D=' + encodeURIComponent(box.dataset.productId) + '&page%5Bsize%5D=40';
      fetch(url, { headers: { 'Junip-Store-Key': key }, signal: request.signal })
        .then(response => response.ok ? response.json() : null)
        .then(data => {
          if (!box.isConnected) return;
          const picks = ((data && data.product_reviews) || []).filter(review => {
            const text = (review.title || '') + ' ' + (review.body || '');
            return review.rating >= 4 && (review.body || '').length >= 60 && (review.body || '').length <= 420 && !skip.test(text);
          }).slice(0, 3);
          if (!picks.length) return;
          const list = box.querySelector('[data-alac-reviews-list]');
          picks.forEach(review => {
            const li = document.createElement('li'); li.className = 'alac-review';
            const stars = document.createElement('span'); stars.className = 'alac-stars'; stars.style.setProperty('--rating', review.rating); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
            const title = document.createElement('p'); title.className = 'alac-review__title'; title.textContent = review.title || '';
            const body = document.createElement('p'); body.className = 'alac-review__body'; body.textContent = review.body;
            const who = document.createElement('p'); who.className = 'alac-review__meta'; who.textContent = (review.verified_buyer ? 'Verified buyer' : 'Customer') + (review.target_title ? ' · ' + review.target_title.replace(/^Alex['’]s Low[- ]Acid Organic Coffee™?\s*[-–]?\s*/i, '') : '');
            li.append(stars, title, body, who); list.append(li);
          });
          list.hidden = false;
        }).catch(() => {});
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); observer = null; load(); } }, { rootMargin: '600px' });
      observer.observe(box);
    } else load();
  }

  window.alacPdpStoryReviews = { mount, unmount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
